import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { TaxonomyService } from '@app/core/services/taxonomy.service';
import { mergeMap, map, catchError, switchMap, first } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromActions from './locations-flat.actions';
import * as fromReducer from './locations-flat.reducer';
import * as fromSlectors from './locations-flat.selectors';

@Injectable()
export class LocationsFlatEffects {

  public loadFunctionsFlat$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadLocationsFlat),
      switchMap(() => this.store$.pipe(
        select(fromSlectors.selectEntities),
        first(entities => this.isEmpty(entities)),
      )),
      mergeMap(() => [
        fromActions.getLocationsFlatRequest()
      ])
    ), { dispatch: true }
  );

  public getLocationsFlatRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.getLocationsFlatRequest),
      mergeMap(() =>
        this.taxonomyService.getLocationsFlat().pipe(
          map((locationsFlat) => fromActions.getLocationsFlatSuccess({ locationsFlat })),
          catchError(({ message }) => of(fromActions.getLocationsFlatFailure({ error: message })))
        )
      )
    ), { dispatch: true }
  );

  public getLocationsFlatSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.getLocationsFlatSuccess),
      mergeMap(({ locationsFlat }) => [
        fromActions.locationsFlatCollectionAddMany({ locationsFlat }),
      ]),
    ), { dispatch: true }
  );

  private isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  constructor(
    private actions$: Actions,
    private store$: Store<fromReducer.State>,
    private taxonomyService: TaxonomyService
  ) {}
}
